import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Logo from "@/components/Logo";
import { useAuth } from "@/context/AuthContext";

const Splash = () => {
    const navigate = useNavigate();
    const { isAuthenticated, user } = useAuth();

    useEffect(() => {
        const t = setTimeout(() => {
            if (!isAuthenticated) {
                navigate("/auth", { replace: true });
            } else if (!user?.onboardingCompleted) {
                navigate("/onboarding", { replace: true });
            } else {
                navigate("/home", { replace: true });
            }
        }, 2000);
        return () => clearTimeout(t);
    }, [navigate, isAuthenticated, user]);

    return (
        <div
            className="screen items-center justify-center px-6"
            data-testid="splash-screen"
        >
            <div
                aria-hidden
                className="pointer-events-none absolute inset-0"
                style={{
                    background:
                        "radial-gradient(600px 400px at 50% 42%, hsl(var(--primary) / 0.18), transparent 60%)",
                }}
            />

            <div className="relative z-10 flex flex-col items-center gap-6 animate-logo-in">
                <Logo size={128} />
                <div
                    className="flex flex-col items-center gap-2 animate-fade-up"
                    style={{ animationDelay: "280ms" }}
                >
                    <h1 className="font-display text-3xl font-semibold tracking-tight text-foreground">
                        Neyra
                    </h1>
                    <p className="text-sm text-muted-foreground">
                        Near you. By you. For you.
                    </p>
                </div>
            </div>

            <div
                className="absolute bottom-16 left-1/2 -translate-x-1/2 animate-fade-in"
                style={{ animationDelay: "600ms" }}
            >
                <div className="flex items-center gap-1.5">
                    <span className="h-1.5 w-1.5 rounded-full bg-primary animate-pulse-soft" />
                    <span
                        className="h-1.5 w-1.5 rounded-full bg-primary animate-pulse-soft"
                        style={{ animationDelay: "200ms" }}
                    />
                    <span
                        className="h-1.5 w-1.5 rounded-full bg-primary animate-pulse-soft"
                        style={{ animationDelay: "400ms" }}
                    />
                </div>
            </div>
        </div>
    );
};

export default Splash;
